'use client'
import React, { useState, createContext } from 'react';import { LayoutContextProps, LayoutConfig, LayoutState } from '../../../types/layout';
import { ChildContainerProps } from '../../../types/types';
export const LayoutContext = createContext({} as LayoutContextProps);

export const LayoutProvider = ({ children }: ChildContainerProps) => {
    const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
        ripple: false,
        inputStyle: 'filled',
        menuMode: 'overlay',
        colorScheme: 'light',
        theme: 'bootstrap4-light-purple',
        scale: 14
    });

    const [layoutState, setLayoutState] = useState<LayoutState>({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false
    });

    const [breadcrumbModel, setBreadcrumbModel] = useState<any[]>([]);
    const [onBreadcrumbClick, setOnBreadcrumbClick] = useState<((label: string) => void) | null>(null);
    const [navigationModule, setNavigationModule] = useState<number | null>(null);
    const [isCartPanelOpen, setIsCartPanelOpen] = useState<boolean>(false);
    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState) => ({ ...prevLayoutState, overlayMenuActive: !prevLayoutState.overlayMenuActive }));
        }

        if (isDesktop()) {
            setLayoutState((prevLayoutState) => ({ ...prevLayoutState, staticMenuDesktopInactive: !prevLayoutState.staticMenuDesktopInactive }));
        } else {
            setLayoutState((prevLayoutState) => ({ ...prevLayoutState, staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive }));
        }
    };

    const toggleProfileSidebar = () => {
        setLayoutState((prevLayoutState) => ({ ...prevLayoutState, profileSidebarVisible: !prevLayoutState.profileSidebarVisible }));
    };

    const isOverlay = () => {
        return layoutConfig.menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const value: LayoutContextProps = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        showProfileSidebar: toggleProfileSidebar,
        breadcrumbModel,
        setBreadcrumbModel,
        onBreadcrumbClick,
        setOnBreadcrumbClick,
        navigationModule,
        setNavigationModule,
        isCartPanelOpen,
        setIsCartPanelOpen
    };

    return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
